<template>
   <v-container>
      <v-card>
         <v-card-title class="d-flex justify-space-between">
            <span class="white--text">{{$t("APPLICATIONS")}}</span>
               <v-btn color="white secondary--text" large :to="{ name: 'AddApplication' }">{{$t("ADD_NEW")}}</v-btn>
         </v-card-title>
         <v-card-text>
            <v-data-table
               :headers="headers"
               :items="serverTranslateArrayKeys(applications, ['appFaculty', 'appSemName', 'appYear'])"
               class="elevation-1 pointer mt-5"
               :footer-props="{
                  showFirstLastPage: true,
                  itemsPerPageOptions: [5, 10, 15, 50, 100]
               }"
               :items-per-page="5"
               :hide-default-footer="applications.length > 0 ? false : true"
            >
            <template v-slot:item="props">
               <tr>
                  <td @click="applicationDetails(props.item)">{{props.item.n}}</td>
                  <td @click="applicationDetails(props.item)">{{props.item.appYear}}</td>
                  <td @click="applicationDetails(props.item)">{{props.item.appSemName}}</td>
                  <td @click="applicationDetails(props.item)">{{props.item.appFaculty}}</td>
                 <td @click="applicationDetails(props.item)">{{props.item.appID}}</td>
                  <td @click="applicationDetails(props.item)">
                      {{ new Date(props.item.appDate).toISOString().slice(0, 10) }}
                  </td>
                    <td @click="applicationDetails(props.item)">{{props.item.desireNumber}}</td>

                  <td>


                    <div class="d-flex align-center">

                    <span class="font-weight-medium">
                                          {{(['5','6',5,6].includes(props.item.status)?$t('UNDER_REVIEW'):statuses[props.item.status])}}
                     </span>
                      <v-tooltip top v-if="[2,'2',8,'8'].includes(props.item.status) && universityHRID ==='1531.' " >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="openNominationCard(props.item)"
                        >
                          <v-icon>mdi-printer</v-icon>
                        </v-btn>
                      </template>

                      <span> {{$t("PRINT_NOMINATION_CARD")}} </span>
                    </v-tooltip>

                  </div>

                     <v-tooltip color="secondary white--text" bottom
                                v-if="((props.item.status == 0 || props.item.status == 4 || props.item.status == -2 ) && props.item.editable == 1) ">
                       <template v-slot:activator="{ on }">
                         <v-btn icon v-on="on">
                           <v-icon meduim color="primary" @click="editApplicationItem(props.item.appID)"
                             >mdi-pencil</v-icon
                           >
                         </v-btn>
                       </template>
                       <span>{{ $t("EDIT") }}</span>
                     </v-tooltip>
                    <!-- <v-tooltip color="secondary white--text" bottom v-if="(props.item.status == 0 || props.item.status == 4 || props.item.status == -2) && props.item.deleteable == 1">
                       <template v-slot:activator="{ on }">
                         <v-btn icon v-on="on">
                           <v-icon
                             meduim
                             color="error"
                             class="mx-2"
                             @click="deleteApplication(props.item.appID)"
                             >mdi-delete</v-icon
                           >
                         </v-btn>
                       </template>
                       <span>{{ $t("DELETE") }}</span>
                     </v-tooltip>-->
                     <span class="font-weight-medium" v-if="props.item.draftIntervalStatus == 'closed'">
                        {{$t("END_APP_DATE")}}
                     </span>
                  </td>
               </tr>
            </template>
            </v-data-table>
         </v-card-text>
      </v-card>
      <ad-confirmDialog ref="confirm"></ad-confirmDialog>
   </v-container>
</template>
<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.js";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
export default {
   mixins: [serverTranslationsMixin],
   components: {
     "ad-confirmDialog": ConfirmDialog,
  },
   mounted(){
     this.listApplications()
   },
   computed: {
    universityHRID() {
      return localStorage.getItem("universityHRID");
    },
     direction: function() {
       return this.$store.state.direction
    },
    statuses: function(){
         return {
         "0":this.$t("DRAFT_APPLY"),
         "-2":this.$t("INITIAL_DRAFT_APPLY"),
         "1":this.$t("UNDER_REVIEW"),
         "-1":this.$t("INITIAL_UNDER_REVIEW"),
         "2":this.$t("ACCEPTED"),
         "3":this.$t("REJECTED"),
         "4":this.$t("TO_BE_COMP"),
         "5":this.$t("ACCEPT_CANDIDATE"),
         "6":this.$t("REJECT_CANDIDATE"),
         "7": this.$t("SEND_NO_FEES"),
         "8": this.$t("TRANSFERRED"),
         "9": this.$t("REFUSED_AS_OTHER_ACCEPTED"),
         "10": this.$t("WAITING")
      }
   },
    headers:function() {
      return [
         {
            text:this.$t("SERIAL"),
   			align: "start",
   			sortable: true,
   			value: "n"
         },
         {
            text:this.$t("ACADEMIC_YEAR"),
            align: "start",
   			value: "appYear"
         },
         {
            text:this.$t("ACADEMIC_SEMESTER"),
            align: "start",
   			value: "appSemName"
         },
         {
            text:this.$t("FACULTY"),
            align: "start",
   			value: "appFaculty"
         },
         {
           text:this.$t("ADMISSION_DATA.APPID"),
                align: "start",
            value: "appID"
         },
            {
            text:this.$t("APPLICATION_DATE"),
            align: "start",
   			value: "appDate"
         },
            {
            text:this.$t("DESIRE_ORDER"),
            align: "start",
   			value: "desireNumber"
         },

         {
            text:this.$t("STATUS"),
            align: "start",
            value: "actions"
         }
      ]
   }
   },
   data() {
      return {
         applications:[],

      }
   },
   methods:{
      openNominationCard(item) {
        const route = this.$router.resolve({
            name: "NominationCard",
            params: {
                appID: item.appID
            }
        });

        window.open(route.href, "_blank");
    },
      listApplications() {
         const academicData = {
            "academicYear":localStorage.getItem("academicYearID"),
            "academicSemester":localStorage.getItem("semesterID")
         }
         this.$http.post("/api/applications/list_applications/", academicData)
         .then(
            res => {
               let applicationsArr = []
               this.applications = []
               if (res.data.data.length > 0) {
                  for (var i = 0; i < res.data.data.length; i++) {
                     let app = {}
                     app = {
                        "n":(i+1),
                        "appYear":res.data.data[i].appYear.appYearName,
                        "appYearID":res.data.data[i].appYear.appYearID,
                        "appSemName":res.data.data[i].appSemester.appSemName,
                        "appSemID":res.data.data[i].appYear.appSemID,
                        "appFaculty":res.data.data[i].appFaculty.appFacName,
                        "appFacultyID":res.data.data[i].appYear.appFacID,
                        "appDate":res.data.data[i].appDate,
                        "draftIntervalStatus":res.data.data[i].draftIntervalStatus,
                        "status":res.data.data[i].appStatus ,
                       "desireNumber":res.data.data[i].desireNumber,
                        // && (res.data.data[i].appStatus <= 4 || res.data.data[i].appStatus == 7)
                        // ? res.data.data[i].appStatus:1,
                        "editable":res.data.data[i].editable,
                        "deleteable":res.data.data[i].deleteable,
                        "appID":res.data.data[i].appID
                     }
                     applicationsArr.push(app)
                  }
                  this.applications = applicationsArr
               }
            },
            err => {
               this.$toasted.show(
                this.serverTranslate(err.response.data.message),
                {
                   type: "error",
                   icon: "error_outline",
                   theme: "bubble",
                   position: "bottom-left",
                   duration: 3000
                }
               );
            }
         )
      },
      editApplicationItem(appID) {
         this.$router.push({name:"EditApplication",params:{id:appID}})
      },
      deleteApplication(appID) {
         this.$refs.confirm
         .open("CONFIRMATION_MESSAGE", "DELETE_CONFIRMATION")
         .then(confirm => {
           if (confirm) {
             const data = {
               "applicationID": appID
             };
             this.$http
             .delete("/api/applications/delete_application/", {data:data})
             .then(
               res => {
                 this.$toasted.show(this.serverTranslate(res.data.message), {
                   type: "success",
                   icon: "check_circle_outline",
                   theme: "bubble",
                   position: "bottom-left",
                   duration: 3000
                 });
                 this.listApplications()
               },
               err => {
                 this.$toasted.show(
                   this.serverTranslate(err.response.data.message),
                   {
                     type: "error",
                     icon: "error_outline",
                     theme: "bubble",
                     position: "bottom-left",
                     duration: 3000
                   }
                 );
               }
             );
           }
         });
      },
      applicationDetails(row) {
         this.$router.push({name:"ViewApplication",params:{id:row.appID}})
      }
   }
}
</script>
<style>
.text-start {
   cursor: pointer;
}
</style>
